interface InputGroupProps extends React.InputHTMLAttributes<HTMLInputElement> {
	label: string;
	htmlFor?: string;
	labelClassName?: string;
	isRequired?: boolean;
}

export function InputGroup({ label, labelClassName, isRequired, ...props }: InputGroupProps) {
	return (
		<label>
			<div data-type-style="label" className={labelClassName}>
				{label}
				{isRequired && <span data-ink="highlight">*</span>}
			</div>
			<input {...props} />
		</label>
	);
}
